// This file is AUTOGENERATED, do not edit it manually!!!

export const activityList = {
    Activities: '1#Actividad#Actividades',
    Activities_Text: '1#{0} actividad#{0} actividades',
    activities_without_dates: 'Actividades sin fechas',
    Activity: 'Actividad',
    Activity_Billing: 'Facturable',
    Activity_Cost: 'Actividad Facturable',
    Activity_CostVariance: 'Variación de Costes',
    Activity_HoursLeft: 'izquierda',
    Activity_InternalCost: 'Coste Real',
    Activity_Profit: 'Beneficio',
    Add_Task: 'Agregar Tarea',
    All_Saved_Views: 'Todas las vistas guardadas',
    Apply_Text: 'Aplicar',
    Archive_Success_Message: 'El proyecto ha sido archivado',
    Baseline_Text: 'Línea de base',
    Board_CreateTaskInProjectPlaceholder: 'Crear en proyecto',
    Board_ShowMore: 'Mostrar más',
    Browse_Views: 'Explorar vistas',
    Budget_problem_project: 'El Costo Real excede el Presupuesto Total',
    Budget_problem_task: 'El Costo Real de la Mano de Obra excede el Presupuesto Total',
    Budget_Text: 'Presupuesto',
    Budget_warning_project: 'El Costo EAC excede el Presupuesto Total',
    Budget_warning_task: 'El Costo de Mano de Obra EAC excede el Presupuesto Total',
    By_Text: 'por',
    CPI_Problem: 'IPC está por debajo del umbral',
    Create: 'Crear',
    CreateNewItem: 'Escriba aquí para crear un nuevo proyecto o actividad...',
    CreateProject_Tooltip: 'Crear un proyecto nuevo',
    CriticalPath_Text: 'Ruta crítica',
    CustomField_No: 'No',
    CustomField_Yes: 'Sí',
    DayPluralFormat: '1#Día#Dias',
    Default_Text: 'Predeterminado',
    Delete_Text: 'Eliminar',
    DeleteEntityConfirmation: '<b>incluye todos los registros de tiempo, mensajes y archivos adjuntos</b> {0}. La acción no se puede deshacer!',
    DeletePermanently: 'Eliminar permanente',
    DeleteVerb: '1#se eliminará de forma permanente#se eliminará de forma permanente',
    DeleteVerbActivity: '1#se eliminará de forma permanente#se eliminará de forma permanente',
    Dependency_AddMore_Text: 'Añadir más dependencias',
    Dependency_Cancel: 'Cancelar',
    Dependency_Choose: 'Seleccione actividad o escriba una palabra clave... ',
    Dependency_days: 'días',
    Dependency_DelayWarningExample: 'Ejemplo: -34, 42',
    Dependency_DelayWarningText: 'Ingrese números del -1000 al 1000',
    Dependency_DependencyCycle: 'Lo sentimos, la dependencia no se puede crear porque la actividad seleccionada crea un bucle de dependencia.',
    Dependency_DependencyType_Text: 'Tipo de dependencia',
    Dependency_DependsOn_Text: 'Depende de',
    Dependency_FinishToStart_Minus1: 'La actividad comienza el día antes {0} termine',
    Dependency_FinishToStart_Minus1_Pattern: 'La actividad comienza <b>el día antes</b> \"{0}\" termine',
    Dependency_FinishToStart_Minus2: 'La actividad comienza {1} despúes {0} termina',
    Dependency_FinishToStart_Minus2_Pattern: 'La actividad comienza <b>{1} despúes</b> \"{0}\" termina',
    Dependency_FinishToStart_Plus0: 'La actividad comienza el día {0} termina',
    Dependency_FinishToStart_Plus0_Pattern: 'La actividad comienza <b>el día</b> \"{0}\" termina',
    Dependency_FinishToStart_Plus1: 'La actividad comienza el día después de {0} termina',
    Dependency_FinishToStart_Plus1_Pattern: 'La actividad comienza <b>el día después de</b> \"{0}\" termina',
    Dependency_FinishToStart_Plus2: 'La actividad comienza {1}después {0} termina',
    Dependency_FinishToStart_Plus2_Pattern: 'La actividad comienza <b>{1} después</b> \"{0}\" termina',
    Dependency_FinishWhenStarted_Text: 'La actividad finaliza cuando se inicia \"{0}\" ',
    Dependency_FinishWhenStarted_Title: 'De Principio a Fin',
    Dependency_Lag_Text: 'Retraso',
    Dependency_ParentChildRelationship: 'Lo sentimos, la dependencia no se puede crear porque una de las actividades es un padre y otra es su hijo (subactividad).',
    Dependency_Reason: 'Motivo',
    Dependency_Remove_Text: 'Quitar',
    Dependency_RemoveSingleDependency_Text: 'Eliminar dependencia',
    Dependency_Save: 'Guardar',
    Dependency_SelectDependsOn_Text: 'Seleccionar Depende de',
    Dependency_StartsWhenFinished_Text: 'La actividad comienza cuando \"{0}\" ha finalizado',
    Dependency_StartsWhenFinished_Title: 'De Fin a Principio',
    Dependency_StartsWhenStarted_Text: 'La actividad comienza cuando se inicia \"{0}\" ',
    Dependency_StartsWhenStarted_Title: 'Empezar a comenzar',
    Dependency_StartToFinish_Minus1: 'La actividad finaliza el día anterior {0} comienza',
    Dependency_StartToFinish_Minus1_Pattern: 'La actividad finaliza <b>el día anterior</b> \"{0}\" comieza',
    Dependency_StartToFinish_Minus2: 'La actividad finaliza {1} despúes {0} comienza',
    Dependency_StartToFinish_Minus2_Pattern: 'La actividad finaliza <b>{1} antes</b> \"{0}\" comieza',
    Dependency_StartToFinish_Plus0: 'La actividad finaliza el día {0} comienza',
    Dependency_StartToFinish_Plus0_Pattern: 'La actividad finaliza <b>el día</b> \"{0}\" comieza',
    Dependency_StartToFinish_Plus1: 'La actividad termina al día siguiente {0} comienza',
    Dependency_StartToFinish_Plus1_Pattern: 'La actividad termina <b>al día siguiente</b> \"{0}\" comieza',
    Dependency_StartToFinish_Plus2: 'La actividad finaliza {1} despúes {0} comienza',
    Dependency_StartToFinish_Plus2_Pattern: 'La actividad finaliza <b>{1} despúes</b> \"{0}\" comieza',
    Dependency_StartToStart_Minus1: 'La actividad comienza el día anterior {0} comienza',
    Dependency_StartToStart_Minus1_Pattern: 'La actividad comienza <b>el día anterior</b> \"{0}\" comieza',
    Dependency_StartToStart_Minus2: 'La actividad comienza {1} antes {0}comienza',
    Dependency_StartToStart_Minus2_Pattern: 'La actividad comienza <b>{1} antes</b> \"{0}\" comieza',
    Dependency_StartToStart_Plus0: 'La actividad comienza el día {0} comienza',
    Dependency_StartToStart_Plus0_Pattern: 'La actividad comienza <b>el día</b> \"{0}\" comieza',
    Dependency_StartToStart_Plus1: 'La actividad comienza al día siguiente {0} comieza',
    Dependency_StartToStart_Plus1_Pattern: 'La actividad comienza <b>al día siguiente</b> \"{0}\" comieza',
    Dependency_StartToStart_Plus2: 'La actividad comienza {1} despúes {0} comienza',
    Dependency_StartToStart_Plus2_Pattern: 'La actividad comienza <b>{1} despúes</b> \"{0}\" comieza',
    Dependency_Warning_Text: 'La operación no se pudo completar. ',
    Details: 'Detalles',
    Edit_Text: 'Editar',
    empty_sorting_list: 'No se encontraron opciones de clasificación',
    EnterProjectName: 'Introduzca nombre del proyecto',
    EnterTaskName: 'Introduzca nombre de la tarea',
    EnterViewName_Text: 'Introduzca nombre de la vista',
    Error_DragAndDrop_BreakingHierarchy: 'Una actividad no puede ser hija de su propia subactividad.',
    Error_DragAndDrop_ChangeParentInFlattenView: 'Cambie la vista plana a jerárquica para cambiar la jerarquía de actividades.',
    Error_DragAndDrop_CycleDependencies: 'Esta operación creará una dependencia cíclica (por ej. la Tarea A depende de la Tarea B, la Tarea B depende de la Tarea A).',
    Error_DragAndDrop_DifferentProjects: 'No se puede mover una actividad a otro proyecto (usar detalles de actividad).',
    Error_DragAndDrop_ReorderWithSorting: 'El reordenamiento de actividades solo está disponible con la opción de clasificación de WBS activada.',
    Error_PresetNotFound: 'La vista seleccionada se ha eliminado o no se ha compartido. Para continuar, actualice la página.',
    EstimatedHours_problem: 'Las horas reales exceden las horas estimadas',
    Export_Activities_Text: 'Exportar actividades a CSV',
    Export_Import_Text: 'Exportación e Importación',
    Export_Projects_Text: 'Exportar proyectos a CSV',
    flat_view: 'Vista plana',
    From: 'de',
    Group_By_Portfolio: 'Agrupar por portafolio',
    Hide_Text: 'Ocultar',
    hide_uncategorized_tasks: 'Ocultar actividades que no coinciden con ningún calendario',
    Hours_Short_Text: 'h',
    Import_CSV_Text: 'Importar de CSV',
    Import_MSProject_Text: 'Importar de MS Project',
    Import_Text: 'Importar',
    Indicator_Counter_Tooltip: 'Número de actividades en riesgo',
    Indicator_Project_Tooltip: 'El proyecto necesita atención en:',
    Indicator_Task_Tooltip: 'La actividad necesita atención en:',
    Learn_More_Text: 'Más información',
    Loading_Text: 'Cargando...',
    More_Tasks: '{0} mas',
    MoreActions_AddActivity: 'Agregar una actividad',
    MoreActions_AddNextActivity: 'Añadir la siguiente actividad',
    MoreActions_AddSubActivity: 'Añadir subactividad',
    MoreActions_SetAsMilestone: 'Establecer como hito',
    MoreActions_UnsetAsMilestone: 'Desajuste como hito',
    My_Presets: 'Mio',
    My_Text: ' Yo',
    MyPresetName_Text: 'Mio',
    NewProject: 'Nuevo Proyecto',
    NewProjectBasedOn: 'Nuevo proyecto basado en {0}',
    NewTask: 'Nueva Tarea',
    No_Portfolio: 'Sin Portafolio',
    No_Templates_Text: 'No se han encontrado plantillas.',
    NoSavedViews_Text: 'No hay vistas guardadas.',
    Of: 'de',
    old_sort_az: 'A→Z',
    old_sort_za: 'Z→A',
    parent_activities: 'Actividades para padres',
    preset_delete: 'Eliminar vista',
    preset_delete_confirmation: 'Eliminar vista {0}?',
    preset_rename: 'Renombrar vista',
    preset_save: 'Guardar vista',
    preset_saveAs: 'Guardar vista como',
    preset_share: 'Comparte con todos en este espacio',
    preset_unshare_confirmation: 'Dejar de ver {0}?',
    Project: 'Proyecto',
    Project_ActualBudgetProfitability: 'Rentabilidad Presupuestaria Real',
    Project_BudgetedCost: 'Presupuesto Total del Proyecto',
    Project_CostVariance: 'Variación de Costes',
    Project_EstimatedBudgetProfitability: 'Rentabilidad Presupuestaria Estimada',
    Project_Expenses: 'Gastos',
    Project_InternalCost: 'Coste Real',
    Project_ProjectBilling: 'Proyecto Facturable',
    Project_ProjectProfit: 'Beneficio del Proyecto',
    Project_ProjectProfitability: 'Rentabilidad',
    ProjectEndDate_problem: 'El proyecto no se completó en la fecha de vencimiento',
    Projects: '1#Proyecto#Proyectos',
    Projects_Text: '1#{0} proyecto#{0} proyectos',
    Rename_Text: 'Renombrar',
    Restore_Text: 'Restaurar',
    Save_Text: 'Guardar',
    SaveAs_Text: 'Guardar como',
    Share_Text: 'Compartir',
    Shared_With_Me: 'Compartido conmigo',
    Show_Text: 'Mostrar',
    SortBy_Text: 'Ordenar por',
    SPI_Problem: 'SPI está por debajo del umbral',
    SubActivities: '1#Subactividad#Subactividades',
    switchToClassicUI: 'Cambiar por IU antigua',
    tab_Board: 'Junta',
    tab_Calendar: 'Calendario',
    tab_Gantt: 'Gantt',
    tab_Table: 'Tabla',
    TargetProfit_warning: 'Beneficio Objetivo inferior al Beneficio Esperado',
    TargetProfitPercentage_warning: 'Beneficio Objetivo (%) inferior al Beneficio Esperado (%)',
    TaskEndDate_problem: 'La tarea no se completó en la fecha de vencimiento',
    Templates_Popup_Title: 'Basado en Plantilla:',
    TimerText: '1#{0}segundo#{0}segundos',
    Tools_Menu_Text: 'Herramientas',
    Tooltip_DefaultPresetIcon: 'Seleccionar o administrar vistas guardadas',
    Tooltip_RevertToDefaultPreset: 'Volver a la vista predeterminada',
    Tooltip_SaveDefaultPreset: 'Guarde su diseño y filtros actuales como una Vista',
    Tooltip_SharedByMePreset: 'Compartido por mi',
    TotalTargetRevenue_warning: 'EAC Facturable inferior al Ingreso Objetivo Total',
    uncategorized_tasks: 'Actividades sin calendarios',
    Unshare_Text: 'Dejar de Compartir',
    WBSNumber_Text: 'WBS',
};
